import React, { useEffect, useState } from 'react';

import {
  getLoginUrl,
  loginAction,
} from '../../../../../public-src/core/js/schibsted-account/index.server.js';
import { useSessionData } from '../../../../../public-src/core/js/schibsted-account/react.server.js';
import { Overlay } from './Overlay.js';
import { frontendConfig } from '../../../../core/system/config/frontend.server.js';

interface LoginWallProps {
  children?: React.ReactNode;
  handleOverlay?: () => void;
}
export const LoginWall: React.FC<LoginWallProps> = ({
  children,
  handleOverlay,
}) => {
  const [overlayVisible, setOverlayVisible] = useState(true);

  useEffect(() => {
    document.documentElement.style.overflowY = 'hidden';

    return () => {
      document.documentElement.style.overflowY = 'auto';
    };
  }, []);

  const session = useSessionData();
  const handleLogin = (event: React.MouseEvent) => {
    event.preventDefault();

    loginAction({ state: `vink-${window.location.href}` });
  };

  const handleHide = () => {
    setOverlayVisible(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    handleOverlay && handleOverlay();
  };

  if (session !== false) {
    return <>{children}</>;
  }
  if (overlayVisible) {
    return (
      <Overlay className="dark-login">
        <button
          className="close-overlay"
          aria-label="Lukk"
          onClick={handleHide}
        >
          <img
            src="https://cdn.aftenposten.no/vink/images/icons/cross_extra_bold.svg"
            alt=""
          />
        </button>
        <a href="/" className="overlay-logo">
          <img
            src={`${frontendConfig.cdnUrlInternal}/vink/images/logo.svg`}
            alt="vink"
          />
        </a>
        <div className="nudge">Logg inn og lagre innhold på Mine Vink</div>
        <a className="action-button" href={getLoginUrl()} onClick={handleLogin}>
          Logg inn
        </a>
      </Overlay>
    );
  }

  return <></>;
};
